import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { get } from 'lodash';

import { OrderSchemaType } from '../order.schema';
import { FormGroup, Label, Input } from '../style';

/** Descrição livre da forma de pagamento: existe só no aço, e só quando a forma é "Outros". */
const SteelPaymentMethodDescription: React.FC = () => {
  const { register, setValue, watch, formState: { errors } } = useFormContext<OrderSchemaType>();
  const paymentMethodName = watch('paymentMethodName');
  const isOutros = paymentMethodName === 'Outros';

  useEffect(() => {
    if (!isOutros) setValue('paymentMethodDescription', undefined, { shouldDirty: true });
  }, [isOutros, setValue]);

  if (!isOutros) return null;

  return (
    <FormGroup>
      <Label htmlFor="paymentMethodDescription">Descrição da Forma</Label>
      <Input
        id="paymentMethodDescription"
        {...register('paymentMethodDescription')}
        placeholder="Descreva a forma de pagamento"
        hasError={!!get(errors, 'paymentMethodDescription')}
      />
    </FormGroup>
  );
};

export default SteelPaymentMethodDescription;
